import React from 'react';
import PropTypes$1 from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { PropTypes } from '@panneau/core';
import { isMessage } from '@panneau/core/utils';

/* eslint-disable react/jsx-props-no-spreading */
var propTypes = {
  children: PropTypes.label.isRequired,
  isHtml: PropTypes$1.bool,
  values: PropTypes$1.object // eslint-disable-line react/forbid-prop-types
};
var defaultProps = {
  isHtml: false,
  values: {}
};
var Label = function Label(_ref) {
  var children = _ref.children,
    isHtml = _ref.isHtml,
    values = _ref.values;
  var Message = isHtml ? FormattedMessage : FormattedMessage;
  return isMessage(children) ? /*#__PURE__*/React.createElement(Message, Object.assign({
    values: values
  }, children)) : children;
};
Label.propTypes = propTypes;
Label.defaultProps = defaultProps;

export { Label as default };
